import { render } from "./DialogPopup.vue?vue&type=template&id=f98e5ff0&scoped=true"
import script from "./DialogPopup.vue?vue&type=script&lang=js"
export * from "./DialogPopup.vue?vue&type=script&lang=js"

import "./DialogPopup.vue?vue&type=style&index=0&id=f98e5ff0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f98e5ff0"]])

export default __exports__